<template>
  <div>
    <v-dialog v-model="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Settings</v-card-title>
        <v-card-text>
          <div class="text-right w-100 mt-2">
            <v-btn color="secondary" @click="resetFilters()" small>
              <v-icon dark small>mdi-reload</v-icon> Reset
            </v-btn>
          </div>
          <p class="body-2 font-weight-bold mt-3 pb-3">Inclusive of relevant topics (%)</p>
          <v-slider
            v-model="settings.relevantKeywords"
            ticks="always"
            step="10"
            :thumb-size="24"
            thumb-label="always"
          ></v-slider>
          <v-divider></v-divider>
          <!-- <p class="mt-2">Relevancy</p>
          <v-slider
            v-model="settings.distance"
            ticks="always"
            step="5"
          ></v-slider>
          <v-divider></v-divider>
          <p>Frequency</p>
          <v-slider
            v-model="settings.frequency"
            ticks="always"
            step="10"
          ></v-slider> -->
          <p class="body-2 font-weight-bold">Location</p>
          <div class="d-flex flex-row">
            <div class="pr-2" style="min-width:50%">
              <p class="body-2 mb-3"><v-icon>mdi-account</v-icon> Influencer</p>
              <v-autocomplete
                v-model="settings.influencerGeos"
                :items="countries"
                dense
                hide-selected
                clearable
                small-chips
                outlined
                hide-details="auto"
                label="Influencer"
                multiple
              >
              </v-autocomplete>
            </div>
            <div>
              <p class="body-2 mb-3"><v-icon>mdi-account-multiple</v-icon> Audience</p>
              <div class="d-flex flex-column">
                <v-autocomplete
                  v-model="settings.audGeos"
                  :items="countries"
                  dense
                  hide-selected       
                  clearable
                  small-chips
                  outlined
                  hide-details="auto"
                  label="Audience"
                  multiple
                >
                </v-autocomplete>
                <v-autocomplete
                  outlined
                  dense      
                  hide-details="auto"
                  :items="searchConfig.percentOptions"
                  v-model="settings.audGeoPercent"
                  style="max-width:90px;margin-top:5px"
                ></v-autocomplete>
              </div>
            </div>
          </div>
          <br>
          <v-divider></v-divider>
          <p class="body-2 font-weight-bold">Gender</p>
          <div class="d-flex flex-row">
            <div style="min-width:50%">
              <p class="body-2 mb-2"><v-icon>mdi-account</v-icon> Influencer</p>
              <v-radio-group class="mt-0" v-model="settings.infGender">
                <v-radio label="Male or Female" value="KNOWN"></v-radio>
                <v-radio label="Male" value="MALE"></v-radio>
                <v-radio label="Female" value="FEMALE"></v-radio>
              </v-radio-group>
            </div>
            <div>
              <p class="body-2 mb-2"><v-icon>mdi-account-multiple</v-icon> Audience</p>
              <v-radio-group class="mt-0" v-model="settings.audGender">
                <v-radio label="Any" value=""></v-radio>
                <v-radio label="Male" value="MALE"></v-radio>
                <v-radio label="Female" value="FEMALE"></v-radio>
              </v-radio-group>
              <v-autocomplete
                  outlined
                  dense      
                  hide-details="auto"
                  :items="searchConfig.percentOptions"
                  v-model="settings.audGenderPercent"
                  style="max-width:90px;"
                  v-if="settings.audGender"
                ></v-autocomplete>
            </div>
          </div>
          <v-divider></v-divider>
          <p class="body-2 font-weight-bold">Followers</p>
          <v-list min-height="100px">
            <v-list-item class="mb-2">
              <v-row>
                <v-col class="pl-0" cols="12" xs="12" md="4" lg="4">
                  From
                  <v-combobox
                    outlined
                    dense        
                    clearable
                    hide-details="auto"
                    :items="searchConfig.followerOptions.from"
                    v-model="settings.followers.from"
                    style="max-width:120px;" 
                  ></v-combobox>
                </v-col>
                <v-col class="pl-0" cols="12" xs="12" md="6" lg="6">
                  To
                  <v-combobox
                    outlined
                    dense        
                    clearable
                    hide-details="auto"
                    :items="searchConfig.followerOptions.to"
                    v-model="settings.followers.to"
                    style="max-width:120px;"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <!-- <div class="d-flex flex-row">
            <div style="min-width:50%">
              <p class="body-2 font-weight-bold">Bio</p>
              <v-text-field
                style="max-width:200px;"
                v-model="settings.bio"
                label="Bio"
                outlined
                dense        
                clearable
                hide-details="auto"
              />
            </div>
            <div>
              <p class="body-2 font-weight-bold">Keywords</p>
              <v-text-field
                style="max-width:200px;"
                v-model="settings.keywords"
                label="Keywords"
                outlined
                dense        
                clearable
                hide-details="auto"
              />
            </div>
          </div>
          <v-divider></v-divider> -->
          <!-- <v-divider></v-divider> -->
          <!-- <div class="d-flex flex-row">
            <div style="min-width:50%">
              <p class="body-2 font-weight-bold">Mentions</p>
              <v-text-field
                style="max-width:200px;"
                v-model="settings.mentions"
                label="Mentions"
                outlined
                dense        
                clearable
                hide-details="auto"
              />
            </div>
            <div>
              <p class="body-2 font-weight-bold">Hashtags</p>
              <v-text-field
                style="max-width:200px;"
                v-model="settings.hashtags"
                label="Hashtags"
                outlined
                dense        
                clearable
                hide-details="auto"
              />
            </div>
          </div> -->
          <!-- <p class="body-2 font-weight-bold">Engagements</p>
          <v-list min-height="100px">
            <v-list-item class="mb-2">
              <v-row>
                <v-col class="pl-0" cols="12" xs="12" md="4" lg="4">
                  From
                  <v-combobox
                    outlined
                    dense        
                    clearable
                    hide-details="auto"
                    :items="searchConfig.engOptions.from"
                    v-model="settings.engagements.from"
                    style="max-width:120px;" 
                  ></v-combobox>
                </v-col>
                <v-col class="pl-0" cols="12" xs="12" md="6" lg="6">
                  To
                  <v-combobox
                    outlined
                    dense        
                    clearable
                    hide-details="auto"
                    :items="searchConfig.engOptions.to"
                    v-model="settings.engagements.to"
                    style="max-width:120px;"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <p class="body-2 font-weight-bold mb-1">Engagement Rate</p>
          <v-list>
            <v-list-item class="mb-2">
              <v-row>
                <v-col class="pl-0" cols="12" xs="12" md="12" lg="12">
                  From (%)
                  <v-combobox
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                    :items="searchConfig.engRatePercentageOptions.from"
                    v-model="settings.engagementRate.from"
                    style="max-width:150px;"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <v-divider></v-divider> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="saveSettings()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import searchConfig from './config';
import countries from '../../../../../static/sources/countries';
export default {
  name: 'SettingsModal',
  props: ['value', 'oldSettings'],
  data () {
    return {
      searchConfig,
      countries: [], // For filter influencer
      infGender: '',
      audGender: '',
      settings: searchConfig.searchSettings
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        if (Object.keys(this.oldSettings).length) {
          this.settings = Object.assign({}, this.oldSettings)
        }
      }
    }
  },
  methods: {
    saveSettings() {
      this.close()
      this.$emit('saveSettings', this.settings)
    },
    getCountries() {
      // Retrieve countries manually
      this.countries = countries
      this.countries = this.countries.map(c => c.name)
      // influencerAPIs.getCountries().then(countries => {
      //   this.countries = countries.map(item => item.name);
      // });
    },
    resetFilters() {
      this.settings = searchConfig.searchSettings
    },
    close() {
      this.$emit('input')
    }
  },
  mounted() {
    this.getCountries()
  }
}
</script>



// WEBPACK FOOTER //
// SettingsModal.vue?5b6706b8